<template>
    <div class="wt-container">
        <p class="introduction-text text-center">
            The {{globalText}} annual green, blue and grey water footprint{{ofInText}}{{perText}}.
        </p>
        <CountryOrBasinSelector/>
        <Table :columns="columns" :rows="rows" :fileName="fileName"></Table>
    </div>
</template>

<script>
import Table from "@/components/shared/Table.vue";
import CountryOrBasinSelector from "@/components/shared/CountryOrBasinSelector.vue"
import { assessment } from "@/services/assessment-model.js";
import { basinCropsByBasin, countryCropsByCountry, countryCropsByCrop, getCountry, getCrop, worldCrops } from "@/services/entity-model.js";
import { getFunctionGetPercentageString, getWFString } from "@/services/data-tools.js";

export default {
    name: "TableCt",
    components: {
        CountryOrBasinSelector,
        Table
    },
    data() {
        return {
            countryCropsByCountry: countryCropsByCountry,
            basinCropsByBasin: basinCropsByBasin,
            countryCropsByCrop: countryCropsByCrop,
            assessment: assessment,
        };
    },
    computed: {
        globalText() {
            if (assessment.assessmentType.name == "world") {
                return "global";
            }
            return "";
        },
        ofInText() {
            if (assessment.assessmentType.name == "crops") {
                if (assessment.crop.cropID == 10001) {
                    return " of all agriculture (all crops)";
                } else if (assessment.crop.cropID == 10002) {
                    return " of all industries";
                } else {
                    return " of " + assessment.crop.name.toLowerCase();
                }
            }
            if (assessment.assessmentType.name == "world") {
                return "";
            }
            return " in " + assessment.getCountryOrBasinName();
        },
        perText() {
            if (assessment.assessmentType.name == "crops") {
                return ", per country";
            }
            return ", per crop or sector";
        },
        columns() {
            const columns = [];
            if (assessment.assessmentType.name == "crops") {
                columns.push({ key: "countryID", label: "Country",        lookupFunction: val => getCountry(val).name });
            } else {
                columns.push({ key: "cropID",    label: "Crop or Sector", lookupFunction: val => getCrop(val).name });
            }
            return columns.concat([
                { key: "greenWF",         label: "Green WF (m³/yr)", dataFunction: val => getWFString(val.toPrecision(2), "yr"), classes: ["group left-row"] },
                { key: "blueWF",          label: "Blue WF (m³/yr)",  dataFunction: val => getWFString(val.toPrecision(2), "yr"), classes: ["group"] },
                { key: "greyWF",          label: "Grey WF (m³/yr)",  dataFunction: val => getWFString(val.toPrecision(2), "yr"), classes: ["group"] },
                { key: "wf",              label: "Total WF (m³/yr)", dataFunction: val => getWFString(val.toPrecision(2), "yr"), classes: ["group right-row"] },
                { key: "greenWFFraction", label: "% of Green WF",    dataFunction: getFunctionGetPercentageString(1) },
                { key: "blueWFFraction",  label: "% of Blue WF",     dataFunction: getFunctionGetPercentageString(1) },
                { key: "greyWFFraction",  label: "% of Grey WF",     dataFunction: getFunctionGetPercentageString(1) },
                { key: "wfFraction",      label: "% of Total WF",    dataFunction: getFunctionGetPercentageString(1) }
            ]);
        },
        rows: function() {
            if (assessment.assessmentType.name == "countries") {
                return countryCropsByCountry;
            } else if (assessment.assessmentType.name == "basins") {
                return basinCropsByBasin;
            } else if (assessment.assessmentType.name == "crops") {
                return countryCropsByCrop;
            }
            return worldCrops;
        },
        fileName: function() {
            if (assessment.assessmentType.name == "crops") {
                return "wf-accounting-" + assessment.crop.name;
            }
            if (assessment.countriesOrBasins.length >= 1) {
                return "wf-accounting-" + assessment.countriesOrBasins[0].name;
            }
            return "wf-accounting-the-world";
        }
    }
}
</script>

